var _rect, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWall3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#330033",
    width: 800,
    height: 800
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#404",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M769 229L1037 260.9M927 880L731 737 520 660 309 538 40 599 295 764 126.5 879.5 40 599-197 493 102 382-31 229 126.5 79.5-69-63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31 229L237 261 390 382 603 493 308.5 537.5 101.5 381.5M370 905L295 764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 660L578 842 731 737 840 599 603 493 520 660 295 764 309 538 390 382 539 269 769 229 577.5 41.5 370 105 295 -36 126.5 79.5 237 261 102 382 40 599 -69 737 127 880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520-140L578.5 42.5 731-63M603 493L539 269 237 261 370 105M902 382L539 269M390 382L102 382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-222 42L126.5 79.5 370 105 539 269 577.5 41.5 927 80 769 229 902 382 603 493 731 737M295-36L577.5 41.5M578 842L295 764M40-201L127 80M102 382L-261 269"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#505"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 229,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539,
    cy: 269,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 603,
    cy: 493,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 731,
    cy: 737,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 660,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 538,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295,
    cy: 764,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 599,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 382,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 80,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 105,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 42,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 261,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 382,
    r: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall3);
export default __webpack_public_path__ + "static/media/wall-3.d11f271d97fae2304636d29bc8e9b4d0.svg";
export { ForwardRef as ReactComponent };